import { apiClient } from '../core/api_helper';
import * as url from './url_helper';

// // Auth Functions
// export const getLoggedInUser = () => {
//   const user = localStorage.getItem("user");
//   return user ? JSON.parse(user) : null;
// };

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem('user');
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postFakeRegister = data =>
  apiClient.create(url.POST_FAKE_REGISTER, data);

// Login Method
export const postFakeLogin = data =>
  apiClient.create(url.POST_FAKE_LOGIN, data);

// Edit profile
export const postJwtProfile = data =>
  apiClient.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = data =>
  apiClient.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url, data) => {
  return apiClient.create(url, data).catch(err => {
    var message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = 'Sorry! the page you are looking for could not be found';
          break;
        case 500:
          message =
            'Sorry! something went wrong, please contact our support team';
          break;
        case 401:
          message = 'Invalid credentials';
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};

// Login Method
export const postJwtLogin = data =>
  apiClient.create(url.POST_FAKE_JWT_LOGIN, data);

// Login Method OIDC
export const postOidcLogin = data => apiClient.create(url.OIDC_LOGIN, data);

// postSocialLogin
export const postSocialLogin = data => apiClient.create(url.SOCIAL_LOGIN, data);

// Calendar
// get Events
export const getEvents = () => apiClient.get(url.GET_EVENTS);

// get Events
export const getCategories = () => apiClient.get(url.GET_CATEGORIES);

// get Upcomming Events
export const getUpCommingEvent = () => apiClient.get(url.GET_UPCOMMINGEVENT);

// add Events
export const addNewEvent = event => apiClient.create(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = event => apiClient.put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = event =>
  apiClient.delete(url.DELETE_EVENT, { headers: { event } });

// Chat
// get Contact
export const getDirectContact = () => apiClient.get(url.GET_DIRECT_CONTACT);

// get Messages
export const getMessages = roomId =>
  apiClient.get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// add Message
export const addMessage = message => apiClient.create(url.ADD_MESSAGE, message);

// add Message
export const deleteMessage = message =>
  apiClient.delete(url.DELETE_MESSAGE, { headers: { message } });

// get Channels
export const getChannels = () => apiClient.get(url.GET_CHANNELS);

// MailBox
//get Mail
export const getMailDetails = () => apiClient.get(url.GET_MAIL_DETAILS);

// delete Mail
export const deleteMail = forId =>
  apiClient.delete(url.DELETE_MAIL, { headers: { forId } });

// Ecommerce
// get Products
export const getProducts = () => apiClient.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = product =>
  apiClient.delete(url.DELETE_PRODUCT + '/' + product);

// add Products
export const addNewProduct = product =>
  apiClient.create(url.ADD_NEW_PRODUCT, product);

// update Products
export const updateProduct = product =>
  apiClient.update(url.UPDATE_PRODUCT + '/' + product._id, product);

// get Orders
export const getOrders = () => apiClient.get(url.GET_ORDERS);

// add Order
export const addNewOrder = order => apiClient.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = order =>
  apiClient.update(url.UPDATE_ORDER + '/' + order._id, order);

// delete Order
export const deleteOrder = order =>
  apiClient.delete(url.DELETE_ORDER + '/' + order);

// get Customers
export const getCustomers = () => apiClient.get(url.GET_CUSTOMERS);

// add Customers
export const addNewCustomer = customer =>
  apiClient.create(url.ADD_NEW_CUSTOMER, customer);

// update Customers
export const updateCustomer = customer =>
  apiClient.update(url.UPDATE_CUSTOMER + '/' + customer._id, customer);

// delete Customers
export const deleteCustomer = customer =>
  apiClient.delete(url.DELETE_CUSTOMER + '/' + customer);

// get Sellers
export const getSellers = () => apiClient.get(url.GET_SELLERS);

// Project
// get Project list
export const getProjectList = () => apiClient.get(url.GET_PROJECT_LIST);

// Tasks
// get Task
export const getTaskList = () => apiClient.get(url.GET_TASK_LIST);

// add Task
export const addNewTask = task => apiClient.create(url.ADD_NEW_TASK, task);

// update Task
export const updateTask = task =>
  apiClient.update(url.UPDATE_TASK + '/' + task._id, task);

// delete Task
export const deleteTask = task =>
  apiClient.delete(url.DELETE_TASK + '/' + task);

// Kanban Board
export const getTasks = () => apiClient.get(url.GET_TASKS);
export const addNewTasks = card => apiClient.create(url.ADD_TASKS, card);
export const updateTasks = card => apiClient.put(url.UPDATE_TASKS, card);
export const deleteTasks = card =>
  apiClient.delete(url.DELETE_TASKS, { headers: { card } });

// CRM
// get Contacts
export const getContacts = () => apiClient.get(url.GET_CONTACTS);

// add Contact
export const addNewContact = contact =>
  apiClient.create(url.ADD_NEW_CONTACT, contact);

// update Contact
export const updateContact = contact =>
  apiClient.update(url.UPDATE_CONTACT + '/' + contact._id, contact);

// delete Contact
export const deleteContact = contact =>
  apiClient.delete(url.DELETE_CONTACT + '/' + contact);

// get Companies
export const getCompanies = () => apiClient.get(url.GET_COMPANIES);

// add Companies
export const addNewCompanies = company =>
  apiClient.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompanies = company =>
  apiClient.update(url.UPDATE_COMPANIES + '/' + company._id, company);

// delete Companies
export const deleteCompanies = company =>
  apiClient.delete(url.DELETE_COMPANIES + '/' + company);

// get Deals
export const getDeals = () => apiClient.get(url.GET_DEALS);

// get Leads
export const getLeads = () => apiClient.get(url.GET_LEADS);

// add Lead
export const addNewLead = lead => apiClient.create(url.ADD_NEW_LEAD, lead);

// update Lead
export const updateLead = lead =>
  apiClient.update(url.UPDATE_LEAD + '/' + lead._id, lead);

// delete Lead
export const deleteLead = lead =>
  apiClient.delete(url.DELETE_LEAD + '/' + lead);

// Crypto
// Transation
export const getTransationList = () => apiClient.get(url.GET_TRANSACTION_LIST);

// Order List
export const getOrderList = () => apiClient.get(url.GET_ORDRER_LIST);

// Invoice
//get Invoice
export const getInvoices = () => apiClient.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = invoice =>
  apiClient.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = invoice =>
  apiClient.update(url.UPDATE_INVOICE + '/' + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = invoice =>
  apiClient.delete(url.DELETE_INVOICE + '/' + invoice);

// Support Tickets
// Tickets
export const getTicketsList = () => apiClient.get(url.GET_TICKETS_LIST);

// add Tickets
export const addNewTicket = ticket =>
  apiClient.create(url.ADD_NEW_TICKET, ticket);

// update Tickets
export const updateTicket = ticket =>
  apiClient.update(url.UPDATE_TICKET + '/' + ticket._id, ticket);

// delete Tickets
export const deleteTicket = ticket =>
  apiClient.delete(url.DELETE_TICKET + '/' + ticket);

// Dashboard Analytics

// Sessions by Countries
export const getAllData = () => apiClient.get(url.GET_ALL_DATA);
export const getHalfYearlyData = () => apiClient.get(url.GET_HALFYEARLY_DATA);
export const getMonthlyData = () => apiClient.get(url.GET_MONTHLY_DATA);

// Audiences Metrics
export const getAllAudiencesMetricsData = () =>
  apiClient.get(url.GET_ALLAUDIENCESMETRICS_DATA);
export const getMonthlyAudiencesMetricsData = () =>
  apiClient.get(url.GET_MONTHLYAUDIENCESMETRICS_DATA);
export const getHalfYearlyAudiencesMetricsData = () =>
  apiClient.get(url.GET_HALFYEARLYAUDIENCESMETRICS_DATA);
export const getYearlyAudiencesMetricsData = () =>
  apiClient.get(url.GET_YEARLYAUDIENCESMETRICS_DATA);

// Users by Device
export const getTodayDeviceData = () => apiClient.get(url.GET_TODAYDEVICE_DATA);
export const getLastWeekDeviceData = () =>
  apiClient.get(url.GET_LASTWEEKDEVICE_DATA);
export const getLastMonthDeviceData = () =>
  apiClient.get(url.GET_LASTMONTHDEVICE_DATA);
export const getCurrentYearDeviceData = () =>
  apiClient.get(url.GET_CURRENTYEARDEVICE_DATA);

// Audiences Sessions by Country
export const getTodaySessionData = () =>
  apiClient.get(url.GET_TODAYSESSION_DATA);
export const getLastWeekSessionData = () =>
  apiClient.get(url.GET_LASTWEEKSESSION_DATA);
export const getLastMonthSessionData = () =>
  apiClient.get(url.GET_LASTMONTHSESSION_DATA);
export const getCurrentYearSessionData = () =>
  apiClient.get(url.GET_CURRENTYEARSESSION_DATA);

// Dashboard CRM

// Balance Overview
export const getTodayBalanceData = () =>
  apiClient.get(url.GET_TODAYBALANCE_DATA);
export const getLastWeekBalanceData = () =>
  apiClient.get(url.GET_LASTWEEKBALANCE_DATA);
export const getLastMonthBalanceData = () =>
  apiClient.get(url.GET_LASTMONTHBALANCE_DATA);
export const getCurrentYearBalanceData = () =>
  apiClient.get(url.GET_CURRENTYEARBALANCE_DATA);

// Dial Type
export const getTodayDealData = () => apiClient.get(url.GET_TODAYDEAL_DATA);
export const getWeeklyDealData = () => apiClient.get(url.GET_WEEKLYDEAL_DATA);
export const getMonthlyDealData = () => apiClient.get(url.GET_MONTHLYDEAL_DATA);
export const getYearlyDealData = () => apiClient.get(url.GET_YEARLYDEAL_DATA);

// Sales Forecast
export const getOctSalesData = () => apiClient.get(url.GET_OCTSALES_DATA);
export const getNovSalesData = () => apiClient.get(url.GET_NOVSALES_DATA);
export const getDecSalesData = () => apiClient.get(url.GET_DECSALES_DATA);
export const getJanSalesData = () => apiClient.get(url.GET_JANSALES_DATA);

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => apiClient.get(url.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () =>
  apiClient.get(url.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () =>
  apiClient.get(url.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => apiClient.get(url.GET_YEARREVENUE_DATA);

// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () =>
  apiClient.get(url.GET_BTCPORTFOLIO_DATA);
export const getUsdPortfolioData = () =>
  apiClient.get(url.GET_USDPORTFOLIO_DATA);
export const getEuroPortfolioData = () =>
  apiClient.get(url.GET_EUROPORTFOLIO_DATA);

// Market Graph
export const getAllMarketData = () => apiClient.get(url.GET_ALLMARKETDATA_DATA);
export const getYearMarketData = () => apiClient.get(url.GET_YEARMARKET_DATA);
export const getMonthMarketData = () => apiClient.get(url.GET_MONTHMARKET_DATA);
export const getWeekMarketData = () => apiClient.get(url.GET_WEEKMARKET_DATA);
export const getHourMarketData = () => apiClient.get(url.GET_HOURMARKET_DATA);

// Dashboard Project
// Project Overview
export const getAllProjectData = () => apiClient.get(url.GET_ALLPROJECT_DATA);
export const getMonthProjectData = () =>
  apiClient.get(url.GET_MONTHPROJECT_DATA);
export const gethalfYearProjectData = () =>
  apiClient.get(url.GET_HALFYEARPROJECT_DATA);
export const getYearProjectData = () => apiClient.get(url.GET_YEARPROJECT_DATA);

// Project Status
export const getAllProjectStatusData = () =>
  apiClient.get(url.GET_ALLPROJECTSTATUS_DATA);
export const getWeekProjectStatusData = () =>
  apiClient.get(url.GET_WEEKPROJECTSTATUS_DATA);
export const getMonthProjectStatusData = () =>
  apiClient.get(url.GET_MONTHPROJECTSTATUS_DATA);
export const getQuarterProjectStatusData = () =>
  apiClient.get(url.GET_QUARTERPROJECTSTATUS_DATA);

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () =>
  apiClient.get(url.GET_ALLMARKETPLACE_DATA);
export const getMonthMarketplaceData = () =>
  apiClient.get(url.GET_MONTHMARKETPLACE_DATA);
export const gethalfYearMarketplaceData = () =>
  apiClient.get(url.GET_HALFYEARMARKETPLACE_DATA);
export const getYearMarketplaceData = () =>
  apiClient.get(url.GET_YEARMARKETPLACE_DATA);

// Project
export const addProjectList = project =>
  apiClient.create(url.ADD_NEW_PROJECT, project);
export const updateProjectList = project =>
  apiClient.put(url.UPDATE_PROJECT, project);
export const deleteProjectList = project =>
  apiClient.delete(url.DELETE_PROJECT, { headers: { project } });

// Pages > Team
export const getTeamData = team => apiClient.get(url.GET_TEAMDATA, team);
export const deleteTeamData = team =>
  apiClient.delete(url.DELETE_TEAMDATA, { headers: { team } });
export const addTeamData = team => apiClient.create(url.ADD_NEW_TEAMDATA, team);
export const updateTeamData = team => apiClient.put(url.UPDATE_TEAMDATA, team);

// File Manager

// Folder
export const getFolders = folder => apiClient.get(url.GET_FOLDERS, folder);
export const deleteFolder = folder =>
  apiClient.delete(url.DELETE_FOLDER, { headers: { folder } });
export const addNewFolder = folder =>
  apiClient.create(url.ADD_NEW_FOLDER, folder);
export const updateFolder = folder => apiClient.put(url.UPDATE_FOLDER, folder);

// File
export const getFiles = file => apiClient.get(url.GET_FILES, file);
export const deleteFile = file =>
  apiClient.delete(url.DELETE_FILE, { headers: { file } });
export const addNewFile = file => apiClient.create(url.ADD_NEW_FILE, file);
export const updateFile = file => apiClient.put(url.UPDATE_FILE, file);

// To Do
export const getTodos = todo => apiClient.get(url.GET_TODOS, todo);
export const deleteTodo = todo =>
  apiClient.delete(url.DELETE_TODO, { headers: { todo } });
export const addNewTodo = todo => apiClient.create(url.ADD_NEW_TODO, todo);
export const updateTodo = todo => apiClient.put(url.UPDATE_TODO, todo);

// To do Project
export const getProjects = project => apiClient.get(url.GET_PROJECTS, project);
export const addNewProject = project =>
  apiClient.create(url.ADD_NEW_TODO_PROJECT, project);

//Job Application
export const getJobApplicationList = () =>
  apiClient.get(url.GET_APPLICATION_LIST);

//API Key
export const getAPIKey = () => apiClient.get(url.GET_API_KEY);
